@if (effectivenessModel && taskCounts) {
    <div class="eff-details-panel">
        <div class="h3-title">
            <span class="section">
                <span
                    [title]="'effControlTaskCountInfoBox.testPlanName' | t"
                    data-uiid="new-eff-info-box-testplan-name"
                    class="info-label regular-text"
                    >{{ effectivenessModel.name }}
                </span>
                <span
                    [title]="'effControlTaskCountInfoBox.startDate' | t"
                    data-uiid="new-eff-info-box-testplan-start-date"
                    class="info-label regular-text"
                    >{{ effectivenessModel.startDate | dateFormat }}</span
                >
                <span class="separator" class="info-label regular-text"> | </span>
                <span
                    [title]="'effControlTaskCountInfoBox.endDate' | t"
                    data-uiid="new-eff-info-box-testplan-end-date"
                    class="info-label regular-text"
                    >{{ effectivenessModel.endDate | dateFormat }}</span
                >
                @if (periodOngoing) {
                    <span [title]="'effControlTaskCountInfoBox.warningIcon' | t" class="warning-icon">
                        <eff-icon
                            [icon]="icon"
                            size="warning"
                            data-uiid="new-eff-info-box-warning-icon"
                        >
                        </eff-icon>
                    </span>
                    <span
                        [title]="'effControlTaskCountInfoBox.warningText' | t"
                        data-uiid="new-eff-info-box-warning-text"
                        class="info-box-warning"
                    >
                        {{ 'effControlTaskCountInfoBox.periodNotFinished' | t }}
                    </span>
                }
            </span>
        </div>
        <div class="rows-container">
            <div class="row-container count-gap">
                <div
                    class="regular-text semibold row-label"
                    data-uiid="new-eff-info-box-population-size-label"
                >
                    {{ 'effControlTaskCountInfoBox.populationSize' | t }}
                </div>
                <div class="regular-text" data-uiid="new-eff-info-box-population-size">
                    {{ taskCounts.populationSize }}
                </div>
            </div>
            <div class="row-container count-gap">
                <div
                    class="regular-text semibold row-label"
                    data-uiid="new-eff-info-box-completed-label"
                >
                    {{ 'effControlTaskCountInfoBox.completed' | t }}
                </div>
                <div class="regular-text" data-uiid="new-eff-info-box-completed">
                    {{ taskCounts.completed }}
                </div>
            </div>

            <div class="row-container count-gap">
                <div
                    class="regular-text semibold row-label"
                    data-uiid="new-eff-info-box-not-completed-label"
                >
                    {{ 'effControlTaskCountInfoBox.notCompleted' | t }}
                </div>
                <div class="regular-text" data-uiid="new-eff-info-box-not-completed">
                    {{ taskCounts.notCompleted }}
                </div>
            </div>
        </div>
        @if (taskCounts.populationSize === 0) {
            <div
                class="regular-text no-executions-label"
                data-uiid="new-eff-info-box-no-tasks-found-label"
            >
                {{ 'effControlTaskCountInfoBox.noControlExecutions' | t }}
            </div>
        }
    </div>
}
